module.exports = __webpack_public_path__ + "media/images/payments/eway-dark-1980b18fcba0ae20538632d294dce4b5.svg";